'use client';
import { jsx } from 'react/jsx-runtime';
import { useOverlayPosition, Overlay } from '@react-aria/overlays';
import { useTooltip } from '@react-aria/tooltip';
import { useRef } from 'react';
import { useInternalDialogConfigContext as g } from '../modal-dialog/dialog.component.js';
import { useModeExtractor } from '../../hooks/use-mode-extractor/index.js';
import { renderWithRef } from '../core/render-with-ref.js';
import { assignRefs } from '../../../core/utilities/ref.utils.js';
import { tokensRaw } from '../../../core/tokens/tokens-raw.js';
import { ROOT_CLASSNAMES } from '../../../core/constants/globals.js';
import { RenderComp } from '../core/render-comp.component.js';

function _define_property(e, r, t) {
    return r in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: true,
        configurable: true,
        writable: true
    }) : e[r] = t, e;
}
function _object_spread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {}, o = Object.keys(t);
        "function" == typeof Object.getOwnPropertySymbols && (o = o.concat(Object.getOwnPropertySymbols(t).filter(function(e) {
            return Object.getOwnPropertyDescriptor(t, e).enumerable;
        }))), o.forEach(function(r) {
            _define_property(e, r, t[r]);
        });
    }
    return e;
}
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        t.push.apply(t, o);
    }
    return t;
}
function _object_spread_props(e, r) {
    return r = null != r ? r : {}, Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : ownKeys(Object(r)).forEach(function(t) {
        Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
    }), e;
}
const IconButtonTooltipInternal = renderWithRef('IconButtonTooltip', null, (p, u)=>{
    var d;
    let { tooltipState: m, triggerRef: b, triggerTooltipProps: O, children: y } = p, { tooltipProps: j } = useTooltip({}, m), { inModal: _, portalRef: w, dialogRef: g$1 } = g(), v = useModeExtractor(b, m.isOpen), P = _ && w.current ? w.current : void 0, h = useRef(null), S = assignRefs(u, h), { overlayProps: D } = useOverlayPosition({
        targetRef: b,
        overlayRef: h,
        isOpen: m.isOpen,
        placement: 'top',
        offset: parseInt(tokensRaw.SwanSemSpace3),
        boundaryElement: _ && (null === (d = g$1.current) || void 0 === d ? void 0 : d.firstElementChild) || void 0
    }), k = new Set([
        ROOT_CLASSNAMES.base,
        'swan-icon-button-tooltip'
    ]);
    return v.hasDarkMode && k.add(ROOT_CLASSNAMES.darkMode), v.hasCompactMode && k.add(ROOT_CLASSNAMES.compactMode), jsx(Overlay, _object_spread_props(_object_spread({}, D), {
        portalContainer: P,
        children: jsx(RenderComp, {
            root: "span",
            forwardedRef: S,
            classNames: k,
            props: _object_spread_props(_object_spread({}, O, j), {
                'aria-hidden': true
            }),
            children: y
        })
    }));
});

export { IconButtonTooltipInternal };
